import { createTheme } from '@mui/material/styles';
import { responsiveFontSizes } from "@mui/material/styles";

export const colors = {
  tealDark: {
    100: '#010706',
    200: '#03100D',
    300: '#051914',
    400: '#08221A',
    500: '#042d3b', // базовый цвет
    600: '#294438',
    700: '#496256',
    800: '#6A8176',
    900: '#8BA098',
  },
  orange: {
    100: '#4A1F0D',
    200: '#713016',
    300: '#9A401C',
    400: '#C45022',
    500: '#EC5E27', // базовый цвет
    600: '#F0784A',
    700: '#F4946D',
    800: '#F8B59A',
    900: '#FCD8CB',
  },
  white: {
    100: '#FFFFFF',
    200: '#F5F5F5',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#ededed', // базовый цвет
    600: '#9b9a9a',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  green: {
    100: '#0B2A19',
    200: '#104526',
    300: '#155F34',
    400: '#1B702F',
    500: '#338455', // базовый цвет
    600: '#57996F',
    700: '#7CAF8D',
    800: '#A4C6B0',
    900: '#CBE0D2',
  },
  gray: {
  100: '#080808',
  200: '#0E0E0E',
  300: '#141414',
  400: '#1B1B1B',
  500: '#232323', // базовый цвет
  600: '#414141',
  700: '#626262',
  800: '#858585',
  900: '#AAAAAA',
},

}


export const getTheme = (mode) => {
  return responsiveFontSizes(
    createTheme({
      palette: {
        mode,
        error: {
          main: "#ff4f71",
        },
        primary: {
          main: colors.gray[500],
          contrastText: colors.white[500],
        },

        secondary: {
          main: colors.gray[200],
        },

        white: {
          main: colors.white[500],
        },

        background: {
          default: mode === 'light' ? '#e8e8e8' : '#0e151f',
          paper: mode === 'light' ? colors.white[100] : '#181f2c',
        },
      },

      typography: {
        fontSize: 13,
        subtitle1: {
          fontWeight: 'bold',
        },
      },

      text: {
        primary: {
          main: mode === 'light' ? colors.tealDark[500] : colors.white[500],
        },
        secondary: {
          main: mode === 'light' ? colors.tealDark[400] : colors.white[400],
        },
        white: {
          main: colors.white[500],
        },
      },

      components: {

        MuiButton: {
          styleOverrides: {
            containedPrimary: {
              backgroundColor: colors.gray[500],
              '&:hover': {
                backgroundColor: colors.gray[400],
              },
            },
          },
        },





      }



    })
  )
}
